/* issue-545 */
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router'

import { AppState } from "store";
import targetComponent from 'components/student/EntrustStudies';
import studentActions from 'actions/studentActions';
import * as Models from 'models/api';
import { curriculums } from 'utils/constants'

const mapDispatchToProps = (dispatch: Dispatch) => ({ dispatch })

const mapStateToProps = (appState: AppState, ownProps: RouteComponentProps) => {
  const user = appState.session.user! as Models.StudentUser

  return {
    user,
    curriculums,
    student: appState.student,
    ...ownProps,
  }
}

const mergeProps = (
  stateProps: ReturnType<typeof mapStateToProps>,
  { dispatch }: ReturnType<typeof mapDispatchToProps>) => {
  return {
    ...stateProps,
    getCurriculum: (code: string | undefined) => {
      return stateProps.curriculums.find(x => x.code === code || x.id === Number(code))
    },
    // おまかせ学習のコンテンツを取得
    fetchEntrustStudyData: (curriculum_id: number) => {
      return new Promise<Models.EntrustCurrentRecords>((resolve, reject) => {
        dispatch(studentActions.fetchEntrustStudyRecords({
          curriculum_id,
          promises: { resolve, reject }
        }))
      })
    },
    getEntrustStudyState: () => {
      const page = stateProps.student.entrustStudy
      if (page.records) {
        return page.records.entrust_current
      }
    },
    // stateからの値取得
    getRecords: (curriculum_id: number) => {
      const page = stateProps.student.recommendStudy
      if (page.curriculum_id !== curriculum_id) {
        return null
      }
      return page.records
    },

    // 単元一覧を取得する
    fetchStudyCourse: (course_id: number) => {
      dispatch(studentActions.fetchStudyCourse({ course_id }))
    },

    // 受講生科目内トピック一覧を取得する
    fetchStudyUnit: (unit_id: number) => {
      dispatch(studentActions.fetchStudyUnit({ unit_id }))
    },

    startStudy: (params: { content_id: number, return_pathname: string, m_entrust: string, rank?: number }) => {
      return new Promise<string>((resolve, reject) => {
        dispatch(studentActions.startStudy({
          params,
          promises: { resolve, reject }
        }))
      })
    },

    getLearningCount: (params: { curriculumCodes: Models.StudentStudyLearningCountParams }) => {
      return new Promise<Models.StudentStudyLearningCountRecords>((resolve, reject) => {
        dispatch(studentActions.getLearningCount({
          params,
          promises: { resolve, reject }
        }))
      })
    },

    getCoursesId: (curriculum_id: number ) => {
      dispatch(studentActions.fetchStudyCurriculum({ curriculum_id }))
    },
    pdfDownload: (curriculum_codes: string[]) => {
      const curriculumCodesString = curriculum_codes.join("_")
      return new Promise<{url: string}>((resolve, reject) => {
        dispatch(studentActions.fetchPdfDownload({
          pdf_curriculums: curriculumCodesString,
          promises: { resolve, reject }
        }))
      })},
    fetchStudyAchievementsLatest: () => {
      return new Promise<Models.StudyAchievementsLatest>((resolve, reject) => {
        dispatch(studentActions.fetchStudyAchievementsLatest(
          { promises: { resolve, reject } }
        ))
      })
    },
  }
}

type connectMappedProps = ReturnType<typeof mergeProps>
export type mappedProps = connectMappedProps;

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(targetComponent))